import { ReactNode } from 'react';
import { useMenus } from '@/providers';
import { useMenuCurrentItem } from '@/components';
import { useLocation } from 'react-router-dom';

export interface IToolbarHeadingProps {
  title?: string | ReactNode;
  description?: string | ReactNode;
  id?: string;
}

const ToolbarHeading = ({
  title = '',
  description,
  id,
}: IToolbarHeadingProps) => {
  const { getMenuConfig } = useMenus();
  const { pathname } = useLocation();
  const currentMenuItem = useMenuCurrentItem(
    pathname,
    getMenuConfig('primary')
  );

  return (
    <div className="flex flex-col justify-center gap-2">
      <h1
        id={id}
        className="text-xl font-medium leading-none text-gray-900 contrast:text-white"
        tabIndex={id ? -1 : undefined}
      >
        {title || currentMenuItem?.title}
      </h1>
      {description && (
        <div className="flex items-center gap-2 text-sm font-normal text-gray-700 contrast:text-white/100">
          {description}
        </div>
      )}
    </div>
  );
};

export { ToolbarHeading };
